/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_Detail_AprInputs */

const en_campaigns_mag7_spacex_detail_apr = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earn 10% APR on your balance on top, paid while the campaign runs.`)
};

const de_campaigns_mag7_spacex_detail_apr = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdienen Sie zusätzlich 10 % APR auf Ihr Guthaben, ausgezahlt während der Laufzeit der Kampagne.`)
};

const pt_br2_campaigns_mag7_spacex_detail_apr = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ganhe 10% de APR adicional sobre seu saldo, pago enquanto a campanha estiver ativa.`)
};

const tr_campaigns_mag7_spacex_detail_apr = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ek olarak bakiyeniz üzerinden %10 APR kazanın; ödemeler kampanya süresince yapılır.`)
};

const zh_cn2_campaigns_mag7_spacex_detail_apr = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还可按余额额外赚取 10% 年化收益，在活动期间发放。`)
};

const zh_hk2_campaigns_mag7_spacex_detail_apr = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更可按結餘額外賺取 10% 年利率，於活動期間派發。`)
};

const ko_kr2_campaigns_mag7_spacex_detail_apr = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잔액에 대해 연 10% APR을 추가로 받으세요. 캠페인 기간 동안 지급됩니다.`)
};

const ru_ru2_campaigns_mag7_spacex_detail_apr = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте сверху 10% годовых на баланс. Выплаты производятся, пока идёт кампания.`)
};

const es_419_campaigns_mag7_spacex_detail_apr = /** @type {(inputs: Campaigns_Mag7_Spacex_Detail_AprInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gana 10% APR adicional sobre tu saldo, pagado mientras dure la campaña.`)
};

/**
* | output |
* | --- |
* | "Earn 10% APR on your balance on top, paid while the campaign runs." |
*
* @param {Campaigns_Mag7_Spacex_Detail_AprInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_detail_apr = /** @type {((inputs?: Campaigns_Mag7_Spacex_Detail_AprInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Detail_AprInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_detail_apr(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_detail_apr(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_detail_apr(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_detail_apr(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_detail_apr(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_detail_apr(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_detail_apr(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_detail_apr(inputs)
	return es_419_campaigns_mag7_spacex_detail_apr(inputs)
});